import { render, staticRenderFns } from "./BouncedEmailActionCell.vue?vue&type=template&id=75b61d5c&scoped=true&"
import script from "./BouncedEmailActionCell.vue?vue&type=script&lang=js&"
export * from "./BouncedEmailActionCell.vue?vue&type=script&lang=js&"
import style0 from "./BouncedEmailActionCell.vue?vue&type=style&index=0&id=75b61d5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b61d5c",
  null
  
)

export default component.exports